window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['cartUpdateForm']) return;

  function cartUpdateForm(data = {}) {
    return {
      ...data,

      isLoadingCartUpdateForm: false,

      get formData() {
        var formData = new FormData(this.$el);

        formData.set('sections', this.$store.cart.sectionIds);

        return formData;
      },

      onSubmit() {
        if (this.isLoadingCartUpdateForm) return;

        dispatchEvent(new CustomEvent('cartchangestart', { detail: { showModal: this.showModal } }));

        this.isLoadingCartUpdateForm = true;

        var fetchUrl = window.global.routes.cart_update_url;

        var fetchOptions = {
          method: this.$el.method,
          body: this.formData,
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          }
        };

        fetch(fetchUrl, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              return res.text().then((err) => { throw new Error(err) });
            }

            return res.json();
          })
          .then((res) => {
            dispatchEvent(new CustomEvent('cartchangesuccess', { detail: { res } }));
          })
          .catch((err) => {
            dispatchEvent(new CustomEvent('cartchangeerror', { detail: { err } }));
          })
          .finally(() => {
            dispatchEvent(new CustomEvent('cartchangeend'));
            this.isLoadingCartUpdateForm = false;
          });
      }
    };
  };

  Alpine.data('cartUpdateForm', cartUpdateForm);

  window.global.registeredAlpineComponents['cartUpdateForm'] = true;
});
